











































import find from 'lodash-es/find';
import get from 'lodash-es/get';
import moment from 'moment-timezone';
import Vue from 'vue';

import TrackingModel from '@/api/tracking/tracking.model';
import Progress, {
  ProgressStep
} from '@/modules/tracking-old/components/Progress.component.vue';
import {
  ERRORS,
  TRACKING_STATUS,
  TRACKING_STATUS_FLOW
} from '@/modules/tracking-old/constants';
import { trackingOldStore } from '@/modules/tracking-old/store';
import Error from '@/ui/components/error.component.vue';

const TRACKING_STATUS_ICONS = {
  [TRACKING_STATUS.CANCELED]: require('@/modules/tracking-old/assets/canceled.svg'),
  [TRACKING_STATUS.DELIVERED]: require('@/modules/tracking-old/assets/delivered.svg'),
  [TRACKING_STATUS.IN_ROUTING]: require('@/modules/tracking-old/assets/in-routing.svg'),
  [TRACKING_STATUS.IN_TREATMENT]: require('@/modules/tracking-old/assets/in-treatment.svg'),
  [TRACKING_STATUS.NOT_DELIVERED]: require('@/modules/tracking-old/assets/not-delivered.svg'),
  [TRACKING_STATUS.PROCESSING]: require('@/modules/tracking-old/assets/processing.svg'),
  [TRACKING_STATUS.RETURNED]: require('@/modules/tracking-old/assets/returned.svg')
};

export default Vue.extend({
  components: {
    Error,
    Progress
  },

  computed: {
    deliveryTrackingStatus() {
      return trackingOldStore.deliveryTrackingStatus;
    },
    title() {
      return `${this.i18n('TRACKING_OLD.MESSAGES.CURRENT_DELIVERY_STATUS')}${
        this.tracking ? ` - ${this.tracking[0]?.status?.name}` : ''
      }`;
    },
    tracking() {
      return trackingOldStore.tracking;
    }
  },
  data() {
    return {
      error: false,
      errorMessage: null,
      get,
      moment,
      steps: []
    };
  },
  methods: {
    buildTrackingGraph(): ProgressStep[] {
      if (!this.tracking?.length) {
        return [];
      }
      // default flow is DELIVERED
      let flow = TRACKING_STATUS_FLOW.DELIVERED;
      let trackings: TrackingModel[] = [...this.tracking];
      let processingIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.PROCESSING
      );

      // only to keep most recent tracking after PROCESSING
      // the PROCESSING step can appear multiple times
      if (processingIndex !== -1) {
        trackings = trackings.slice(0, processingIndex + 1);
      }

      // get index of tracking status
      // later this will be used to verify which flow to use
      processingIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.PROCESSING
      );
      const inRoutingIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.IN_ROUTING
      );
      const canceledIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.CANCELED
      );
      const returnedIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.RETURNED
      );
      const notDeliveredIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.NOT_DELIVERED
      );
      const deliveredIndex = trackings.findIndex(
        tracking => tracking?.status?.code === TRACKING_STATUS.DELIVERED
      );

      if (canceledIndex !== -1 && processingIndex === -1) {
        // delivery tracking is CANCELED_BEFORE_PROCESSING
        flow = TRACKING_STATUS_FLOW.CANCELED_BEFORE_PROCESSING;
      } else if (canceledIndex !== -1 && processingIndex !== -1) {
        // delivery tracking is CANCELED_AFTER_PROCESSING
        flow = TRACKING_STATUS_FLOW.CANCELED_AFTER_PROCESSING;
      } else if (returnedIndex !== -1 && inRoutingIndex === -1) {
        // delivery tracking is RETURNED_BEFORE_IN_ROUTING
        flow = TRACKING_STATUS_FLOW.RETURNED_BEFORE_IN_ROUTING;
      } else if (
        notDeliveredIndex !== -1 &&
        (notDeliveredIndex < deliveredIndex || deliveredIndex === -1)
      ) {
        // delivery tracking is NOT_DELIVERED_OR_RETURNED_AFTER_IN_ROUTING
        // notDeliveredIndex < deliveredIndex || deliveredIndex === -1 :
        // in case it have DELIVERED tracking at same time
        // only enter this flow if NOT_DELIVERED is more recent than DELIVERED
        flow = TRACKING_STATUS_FLOW.NOT_DELIVERED_OR_RETURNED_AFTER_IN_ROUTING;

        // only use flow steps that are present in the tracking
        flow = flow.filter(
          step =>
            trackings.findIndex(tracking => tracking?.status?.code === step) !==
            -1
        );
      }

      return flow.map(step => {
        const tracking =
          trackings.find(tracking => tracking?.status?.code === step) || null;
        return {
          bottomLabel: find(
            this.deliveryTrackingStatus,
            status => status.code === step
          )?.name,
          completed: !!tracking,
          icon: TRACKING_STATUS_ICONS[step],
          topLabel: tracking
            ? moment(tracking.statusDate).format('DD/MM/YYYY HH:mm')
            : ''
        };
      });
    }
  },
  async mounted() {
    this.isLoading = true;
    try {
      await trackingOldStore.getData(this.$route?.params?.trackingNumber);
      await trackingOldStore.getDeliveryTrackingStatus();
      this.steps = this.buildTrackingGraph();
    } catch (error) {
      const errorCode = error?.raw?.code;

      if (errorCode === ERRORS.TRACKING_NOT_FOUND) {
        this.$router.push({ name: 'NotFound' });
      } else if (errorCode === ERRORS.INVALID_TRACKING_NUMBER) {
        this.$router.push({ name: 'InvalidTrackingNumber' });
      } else {
        this.errorMessage = this.i18n('MAIN.ERRORS.BASE');
        this.error = true;
      }
    } finally {
      this.isLoading = false;
    }
  }
});
